export default __webpack_public_path__ + "static/technologies-95c857a7b428c77bb24488fa68a8cf9f.png";